<template>
<div>
  <vs-row class="mb-4">
    <vs-col
    ><h5><i class="dot"></i>근골격계부담작업</h5></vs-col
    >
  </vs-row>
  <div>
    <!-- PC 버전 -->
    <div class="hidden xl:block">
      <div class="overflow-x-auto" style="border: 1px solid #cdcdcd; border-bottom: none;">
        <!-- 구분 -->
        <vs-row class="grid-title-11">
          <vs-col class="grid-title head">
            <div>
              <span>구분</span>
              <div v-if="!isPrint" class="mt-2" style="display: flex; font-family: 'Noto Sans KR'; font-style: normal; font-weight: 500; font-size: 12px; line-height: 120%; color: #696D71;">
                <span><feather-icon icon="AlertCircleIcon" svgClasses="h-5 w-5" class="mr-1" /></span>
                <span>작업 그림 클릭 시 작업 해설을 확인할 수 있습니다.</span>
              </div>
            </div>
          </vs-col>
          <vs-col class="grid-11">
            <div class="item">
              <vx-tooltip title="근골격계부담작업 제1호" :html="'하루에 4시간 이상 집중적으로 자료입력 등을 위해 키보드 또는 마우스를 조작하는 작업<br>'+
                                                              '<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>'"
                          style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                          position="top" delay=".1s">
                <div class="grid justify-center cursor-pointer" style="align-items: center;" @click="showPopup(1)">
                  <span>제 ①호</span>
                  <img src="@/assets/images/MusculoskeletalTensionExercisesTable/1.png" alt="제 1호" />
                </div>
              </vx-tooltip>

            </div>
            <div class="item">
              <vx-tooltip title="근골격계부담작업 제2호" :html="'하루에 총 2시간 이상 목,어깨,팔꿈치, 손목 또는 손을 사용하여 같은 동작을 반복하는 작업<br>'+
                                                              '<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>'"
                          style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                          position="top" delay=".1s">
                <div class="grid justify-center cursor-pointer" style="align-items: center;" @click="showPopup(2)">
                  <span>제 ②호</span>
                  <img src="@/assets/images/MusculoskeletalTensionExercisesTable/2.png" alt="제 2호" />
                </div>
              </vx-tooltip>
            </div>
            <div class="item">
              <vx-tooltip title="근골격계부담작업 제3호" :html="'하루에 총 2시간 이상 머리 위에 손이 있거나, 팔꿈치가 어깨 위에 있거나, 팔꿈치를 몸통으로부터 들거나,팔꿈치를 몸통뒤쪽에 위치하도록 하는 상태에서 이루어지는 작업<br>'+
                                                              '<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>'"
                          style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                          position="top" delay=".1s">
                <div class="grid justify-center cursor-pointer" style="align-items: center;" @click="showPopup(3)">
                  <span>제 ③호</span>
                  <img src="@/assets/images/MusculoskeletalTensionExercisesTable/3.png" alt="제 3호" />
                </div>
              </vx-tooltip>
            </div>
            <div class="item">
              <vx-tooltip title="근골격계부담작업 제4호" :html="'지지되지 않은 상태이거나 임의로 자세를 바꿀 수 없는 조건에서, 하루에 총 2시간이상 목이나 허리를 구부리거나 트는 상태에서 이루어지는 작업<br>'+
                                                              '<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>'"
                          style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                          position="top" delay=".1s">
                <div class="grid justify-center cursor-pointer" style="align-items: center;" @click="showPopup(4)">
                  <span>제 ④호</span>
                  <img src="@/assets/images/MusculoskeletalTensionExercisesTable/4.png" alt="제 4호" />
                </div>
              </vx-tooltip>
            </div>
            <div class="item">
              <vx-tooltip title="근골격계부담작업 제5호" :html="'하루에 총 2시간 이상 쪼그리고 앉거나 무릎을 굽힌 자세에서 이루어지는 작업<br>'+
                                                              '<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>'"
                          style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                          position="top" delay=".1s">
                <div class="grid justify-center cursor-pointer" style="align-items: center;" @click="showPopup(5)">
                  <span>제 ⑤호</span>
                  <img src="@/assets/images/MusculoskeletalTensionExercisesTable/5.png" alt="제 5호" />
                </div>
              </vx-tooltip>
            </div>
            <div class="item">
              <vx-tooltip title="근골격계부담작업 제6호" :html="'하루에 총 2시간 이상 지지되지 않은 상태에서 1kg이상의 물건을 한손의 손가락으로 집어 옮기거나,2kg이상에 상응하는 힘을 가하여 한손의 손가락으로 물건을 쥐는 작업<br>'+
                                                              '<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>'"
                          style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                          position="top" delay=".1s">
                <div class="grid justify-center cursor-pointer" style="align-items: center;" @click="showPopup(6)">
                  <span>제 ⑥호</span>
                  <img src="@/assets/images/MusculoskeletalTensionExercisesTable/6.png" alt="제 6호" />
                </div>
              </vx-tooltip>
            </div>
            <div class="item">
              <vx-tooltip title="근골격계부담작업 제7호" :html="'하루에 총 2시간 이상 지지되지 않은 상태에서 4.5kg이상의 물건을 한 손으로 들거나 동일한 힘으로 쥐는 작업<br>'+
                                                              '<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>'"
                          style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                          position="top" delay=".1s">
                <div class="grid justify-center cursor-pointer" style="align-items: center;" @click="showPopup(7)">
                  <span>제 ⑦호</span>
                  <img src="@/assets/images/MusculoskeletalTensionExercisesTable/7.png" alt="제 7호" />
                </div>
              </vx-tooltip>
            </div>
            <div class="item">
              <vx-tooltip title="근골격계부담작업 제8호" :html="'하루에 10회 이상 25kg이상의 물체를 드는 작업<br>'+
                                                              '<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>'"
                          style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                          position="top" delay=".1s">
                <div class="grid justify-center cursor-pointer" style="align-items: center;" @click="showPopup(8)">
                  <span>제 ⑧호</span>
                  <img src="@/assets/images/MusculoskeletalTensionExercisesTable/8.png" alt="제 8호" />
                </div>
              </vx-tooltip>
            </div>
            <div class="item">
              <vx-tooltip title="근골격계부담작업 제9호" :html="'하루에 25회 이상 10kg이상의 물체를 무릎 아래에서 들거나,어깨 위에서 들거나,팔을 뻗은 상태에서 드는 작업<br>'+
                                                              '<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>'"
                          style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                          position="top" delay=".1s">
                <div class="grid justify-center cursor-pointer" style="align-items: center;" @click="showPopup(9)">
                  <span>제 ⑨호</span>
                  <img src="@/assets/images/MusculoskeletalTensionExercisesTable/9.png" alt="제 9호" />
                </div>
              </vx-tooltip>
            </div>
            <div class="item">
              <vx-tooltip title="근골격계부담작업 제10호" :html="'하루에 총 2시간 이상,분당 2회 이상 4.5kg 이상의 물체를 드는 작업<br>'+
                                                              '<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>'"
                          style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                          position="top" delay=".1s">
                <div class="grid justify-center cursor-pointer" style="align-items: center;" @click="showPopup(10)">
                  <span>제 ⑩호</span>
                  <img src="@/assets/images/MusculoskeletalTensionExercisesTable/10.png" alt="제 10호" />
                </div>
              </vx-tooltip>
            </div>
            <div class="item">
              <vx-tooltip title="근골격계부담작업 제11호" :html="'하루에 총 2시간 이상 시간당 10회 이상 손 또는 무릎을 사용하여 반복적으로 충격을 가하는 작업<br>'+
                                                              '<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>'"
                          style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                          position="top" delay=".1s">
                <div class="grid justify-center cursor-pointer" style="align-items: center;" @click="showPopup(11)">
                  <span>제 ⑪호</span>
                  <img src="@/assets/images/MusculoskeletalTensionExercisesTable/11.png" alt="제 11호" />
                </div>
              </vx-tooltip>
            </div>
          </vs-col>
        </vs-row>

        <!-- 노출시간 -->
        <vs-row class="grid-title-11">
          <vs-col class="grid-title head"> 노출시간 </vs-col>
          <vs-col class="grid-11">
            <div class="item">
              <div class="flex" style="align-items: center;">하루에 총<br>4시간 이상</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">하루에 총<br>2시간 이상</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">하루에 총<br>2시간 이상</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">하루에 총<br>2시간 이상</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">하루에 총<br>2시간 이상</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">하루에 총<br>2시간 이상</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">하루에 총<br>2시간 이상</div>
            </div>
            <div class="item head">
              <div class="flex" style="align-items: center;">-</div>
            </div>
            <div class="item head">
              <div class="flex" style="align-items: center;">-</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">하루에 총<br>2시간 이상</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">하루에 총<br>2시간 이상</div>
            </div>
          </vs-col>
        </vs-row>

        <!-- 노출빈도 -->
        <vs-row class="grid-title-11">
          <vs-col class="grid-title head"> 노출빈도 </vs-col>
          <vs-col class="grid-11">
            <div class="item head">
              <div class="flex" style="align-items: center;">-</div>
            </div>
            <div class="item head">
              <div class="flex" style="align-items: center;">-</div>
            </div>
            <div class="item head">
              <div class="flex" style="align-items: center;">-</div>
            </div>
            <div class="item head">
              <div class="flex" style="align-items: center;">-</div>
            </div>
            <div class="item head">
              <div class="flex" style="align-items: center;">-</div>
            </div>
            <div class="item head">
              <div class="flex" style="align-items: center;">-</div>
            </div>
            <div class="item head">
              <div class="flex" style="align-items: center;">-</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">하루에<br>총 10회 이상</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">하루에<br>총 25회 이상</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">분당<br>2회 이상</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">시간당<br>10회 이상</div>
            </div>
          </vs-col>
        </vs-row>

        <!-- 신체부위 -->
        <vs-row class="grid-title-11">
          <vs-col class="grid-title head"> 신체부위 </vs-col>
          <vs-col class="grid-11">
            <div class="item">
              <div class="flex" style="align-items: center;">손, 손가락,<br>팔, 어깨</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">목, 어깨,손<br>목, 손,팔꿈치</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">어깨, 팔</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">목, 허리</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">다리, 무릎</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">손가락</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">손</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">허리</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">손, 무릎</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">허리</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">손, 무릎,<br>팔꿈치</div>
            </div>
          </vs-col>
        </vs-row>

        <!-- 작업자세 및 내용 -->
        <vs-row class="grid-title-11">
          <vs-col class="grid-title head"> 작업자세 및 내용 </vs-col>
          <vs-col class="grid-11">
            <div class="item">
              <div class="flex" style="align-items: center;">집중적인 자료 입력 작업 (마우스, 키보드 사용)</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">같은 동작 반복작업</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">머리 위에 손, 팔꿈치가 몸통으로부터 들림, 팔꿈치를 몸통 뒤쪽에 위치</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">구부리거나 비틈 (지지되지 않은 상태,자세변경불가)</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">쪼그리고 앉거나 무릎을 굽힘</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">한 손가락 집어 옮기거나 쥐는 작업 (지지되지 않은 상태)</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">물건을 한손으로 들거나 잡는 작업</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">물건을 드는 작업</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">어깨 위에서 들기, 팔을 뻗은 상태에서 물건을 드는 작업</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">물건을 드는 작업</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">반복적인 충격</div>
            </div>
          </vs-col>
        </vs-row>

        <!-- 무게 -->
        <vs-row class="grid-title-11">
          <vs-col class="grid-title head"> 무게 </vs-col>
          <vs-col class="grid-11">
            <div class="item head">
              <div class="flex" style="align-items: center;">-</div>
            </div>
            <div class="item head">
              <div class="flex" style="align-items: center;">-</div>
            </div>
            <div class="item head">
              <div class="flex" style="align-items: center;">-</div>
            </div>
            <div class="item head">
              <div class="flex" style="align-items: center;">-</div>
            </div>
            <div class="item head">
              <div class="flex" style="align-items: center;">-</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">1kg이상의 물건 들기, 2kg이상에 상응하는 힘으로 쥐기</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">4.5kg이상의 물건 들기, 동일한 힘으로집기</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">25kg이상</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">10kg이상</div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center;">4.5kg이상</div>
            </div>
            <div class="item head">
              <div class="flex" style="align-items: center;">-</div>
            </div>
          </vs-col>
        </vs-row>
      </div>
    </div>

    <!-- 모바일 버전 -->
    <div class="block xl:hidden">
      <div v-if="!isPrint" class="mb-4" style="display: flex; font-family: 'Noto Sans KR'; font-style: normal; font-weight: 500; font-size: 12px; line-height: 120%; color: #696D71;">
        <span><feather-icon icon="AlertCircleIcon" svgClasses="h-5 w-5" class="mr-1" /></span>
        <span>작업 번호 클릭 시 작업 해설을 확인할 수 있습니다.</span>
      </div>

      <!-- 모바일 카드 리스트 -->
      <div class="mobile-cards">
        <!-- 카드 1 -->
        <div class="mobile-card">
          <div class="mobile-card-header" @click="showPopup(1)">
            <div class="mobile-card-title">
              <span class="mobile-card-number">제 ①호</span>
              <span>자료입력 작업</span>
            </div>
            <img src="@/assets/images/MusculoskeletalTensionExercisesTable/1.png" alt="제 1호" class="mobile-card-img" />
          </div>
          <div class="mobile-card-body">
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출시간</span>
              <span>하루에 총 4시간 이상</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출빈도</span>
              <span>-</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">신체부위</span>
              <span>손, 손가락, 팔, 어깨</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">작업자세 및 내용</span>
              <span>집중적인 자료 입력 작업 (마우스, 키보드 사용)</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">무게</span>
              <span>-</span>
            </div>
          </div>
        </div>

        <!-- 카드 2 -->
        <div class="mobile-card">
          <div class="mobile-card-header" @click="showPopup(2)">
            <div class="mobile-card-title">
              <span class="mobile-card-number">제 ②호</span>
              <span>반복 작업</span>
            </div>
            <img src="@/assets/images/MusculoskeletalTensionExercisesTable/2.png" alt="제 2호" class="mobile-card-img" />
          </div>
          <div class="mobile-card-body">
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출시간</span>
              <span>하루에 총 2시간 이상</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출빈도</span>
              <span>-</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">신체부위</span>
              <span>목, 어깨, 손목, 손, 팔꿈치</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">작업자세 및 내용</span>
              <span>같은 동작 반복작업</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">무게</span>
              <span>-</span>
            </div>
          </div>
        </div>

        <!-- 카드 3 -->
        <div class="mobile-card">
          <div class="mobile-card-header" @click="showPopup(3)">
            <div class="mobile-card-title">
              <span class="mobile-card-number">제 ③호</span>
              <span>팔 위치 작업</span>
            </div>
            <img src="@/assets/images/MusculoskeletalTensionExercisesTable/3.png" alt="제 3호" class="mobile-card-img" />
          </div>
          <div class="mobile-card-body">
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출시간</span>
              <span>하루에 총 2시간 이상</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출빈도</span>
              <span>-</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">신체부위</span>
              <span>어깨, 팔</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">작업자세 및 내용</span>
              <span>머리 위에 손, 팔꿈치가 몸통으로부터 들림, 팔꿈치를 몸통 뒤쪽에 위치</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">무게</span>
              <span>-</span>
            </div>
          </div>
        </div>

        <!-- 카드 4 -->
        <div class="mobile-card">
          <div class="mobile-card-header" @click="showPopup(4)">
            <div class="mobile-card-title">
              <span class="mobile-card-number">제 ④호</span>
              <span>목/허리 작업</span>
            </div>
            <img src="@/assets/images/MusculoskeletalTensionExercisesTable/4.png" alt="제 4호" class="mobile-card-img" />
          </div>
          <div class="mobile-card-body">
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출시간</span>
              <span>하루에 총 2시간 이상</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출빈도</span>
              <span>-</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">신체부위</span>
              <span>목, 허리</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">작업자세 및 내용</span>
              <span>구부리거나 비틈 (지지되지 않은 상태, 자세변경불가)</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">무게</span>
              <span>-</span>
            </div>
          </div>
        </div>

        <!-- 카드 5 -->
        <div class="mobile-card">
          <div class="mobile-card-header" @click="showPopup(5)">
            <div class="mobile-card-title">
              <span class="mobile-card-number">제 ⑤호</span>
              <span>무릎 작업</span>
            </div>
            <img src="@/assets/images/MusculoskeletalTensionExercisesTable/5.png" alt="제 5호" class="mobile-card-img" />
          </div>
          <div class="mobile-card-body">
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출시간</span>
              <span>하루에 총 2시간 이상</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출빈도</span>
              <span>-</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">신체부위</span>
              <span>다리, 무릎</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">작업자세 및 내용</span>
              <span>쪼그리고 앉거나 무릎을 굽힘</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">무게</span>
              <span>-</span>
            </div>
          </div>
        </div>

        <!-- 카드 6 -->
        <div class="mobile-card">
          <div class="mobile-card-header" @click="showPopup(6)">
            <div class="mobile-card-title">
              <span class="mobile-card-number">제 ⑥호</span>
              <span>손가락 작업</span>
            </div>
            <img src="@/assets/images/MusculoskeletalTensionExercisesTable/6.png" alt="제 6호" class="mobile-card-img" />
          </div>
          <div class="mobile-card-body">
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출시간</span>
              <span>하루에 총 2시간 이상</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출빈도</span>
              <span>-</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">신체부위</span>
              <span>손가락</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">작업자세 및 내용</span>
              <span>한 손가락 집어 옮기거나 쥐는 작업 (지지되지 않은 상태)</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">무게</span>
              <span>1kg이상의 물건 들기, 2kg이상에 상응하는 힘으로 쥐기</span>
            </div>
          </div>
        </div>

        <!-- 카드 7 -->
        <div class="mobile-card">
          <div class="mobile-card-header" @click="showPopup(7)">
            <div class="mobile-card-title">
              <span class="mobile-card-number">제 ⑦호</span>
              <span>한 손 작업</span>
            </div>
            <img src="@/assets/images/MusculoskeletalTensionExercisesTable/7.png" alt="제 7호" class="mobile-card-img" />
          </div>
          <div class="mobile-card-body">
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출시간</span>
              <span>하루에 총 2시간 이상</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출빈도</span>
              <span>-</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">신체부위</span>
              <span>손</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">작업자세 및 내용</span>
              <span>물건을 한손으로 들거나 잡는 작업</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">무게</span>
              <span>4.5kg이상의 물건 들기, 동일한 힘으로집기</span>
            </div>
          </div>
        </div>

        <!-- 카드 8 -->
        <div class="mobile-card">
          <div class="mobile-card-header" @click="showPopup(8)">
            <div class="mobile-card-title">
              <span class="mobile-card-number">제 ⑧호</span>
              <span>무거운 물체</span>
            </div>
            <img src="@/assets/images/MusculoskeletalTensionExercisesTable/8.png" alt="제 8호" class="mobile-card-img" />
          </div>
          <div class="mobile-card-body">
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출시간</span>
              <span>-</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출빈도</span>
              <span>하루에 총 10회 이상</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">신체부위</span>
              <span>허리</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">작업자세 및 내용</span>
              <span>물건을 드는 작업</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">무게</span>
              <span>25kg이상</span>
            </div>
          </div>
        </div>

        <!-- 카드 9 -->
        <div class="mobile-card">
          <div class="mobile-card-header" @click="showPopup(9)">
            <div class="mobile-card-title">
              <span class="mobile-card-number">제 ⑨호</span>
              <span>자세별 물체</span>
            </div>
            <img src="@/assets/images/MusculoskeletalTensionExercisesTable/9.png" alt="제 9호" class="mobile-card-img" />
          </div>
          <div class="mobile-card-body">
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출시간</span>
              <span>-</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출빈도</span>
              <span>하루에 총 25회 이상</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">신체부위</span>
              <span>손, 무릎</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">작업자세 및 내용</span>
              <span>어깨 위에서 들기, 팔을 뻗은 상태에서 물건을 드는 작업</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">무게</span>
              <span>10kg이상</span>
            </div>
          </div>
        </div>

        <!-- 카드 10 -->
        <div class="mobile-card">
          <div class="mobile-card-header" @click="showPopup(10)">
            <div class="mobile-card-title">
              <span class="mobile-card-number">제 ⑩호</span>
              <span>빈번한 드는 작업</span>
            </div>
            <img src="@/assets/images/MusculoskeletalTensionExercisesTable/10.png" alt="제 10호" class="mobile-card-img" />
          </div>
          <div class="mobile-card-body">
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출시간</span>
              <span>하루에 총 2시간 이상</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출빈도</span>
              <span>분당 2회 이상</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">신체부위</span>
              <span>허리</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">작업자세 및 내용</span>
              <span>물건을 드는 작업</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">무게</span>
              <span>4.5kg이상</span>
            </div>
          </div>
        </div>

        <!-- 카드 11 -->
        <div class="mobile-card">
          <div class="mobile-card-header" @click="showPopup(11)">
            <div class="mobile-card-title">
              <span class="mobile-card-number">제 ⑪호</span>
              <span>충격 작업</span>
            </div>
            <img src="@/assets/images/MusculoskeletalTensionExercisesTable/11.png" alt="제 11호" class="mobile-card-img" />
          </div>
          <div class="mobile-card-body">
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출시간</span>
              <span>하루에 총 2시간 이상</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">노출빈도</span>
              <span>시간당 10회 이상</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">신체부위</span>
              <span>손, 무릎, 팔꿈치</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">작업자세 및 내용</span>
              <span>반복적인 충격</span>
            </div>
            <div class="mobile-card-item">
              <span class="mobile-card-label">무게</span>
              <span>-</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="py-4 hidden xl:flex">
      <vs-col class="w-auto ml-auto flex" style="color: #7E72F2;">
        <span class="mr-4 cursor-pointer" style="display: flex; align-items: center;" @click="addItem">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8335 4.16536C10.8335 3.70513 10.4604 3.33203 10.0002 3.33203C9.53993 3.33203 9.16683 3.70513 9.16683 4.16536V9.16537H4.16683C3.70659 9.16537 3.3335 9.53846 3.3335 9.9987C3.3335 10.4589 3.70659 10.832 4.16683 10.832H9.16683V15.832C9.16683 16.2923 9.53993 16.6654 10.0002 16.6654C10.4604 16.6654 10.8335 16.2923 10.8335 15.832V10.832H15.8335C16.2937 10.832 16.6668 10.4589 16.6668 9.9987C16.6668 9.53846 16.2937 9.16537 15.8335 9.16537H10.8335V4.16536Z" fill="#7E72F2"/>
          </svg>
          항목추가
        </span>
        <span v-if="value.length > 0" class="mr-4 cursor-pointer" style="display: flex; align-items: center;" @click="removeItem">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.3335 10.0013C3.3335 9.54106 3.70659 9.16797 4.16683 9.16797H15.8335C16.2937 9.16797 16.6668 9.54106 16.6668 10.0013C16.6668 10.4615 16.2937 10.8346 15.8335 10.8346H4.16683C3.70659 10.8346 3.3335 10.4615 3.3335 10.0013Z" fill="#7E72F2"/>
          </svg>
          항목삭제
        </span>
      </vs-col>
    </div>

    <!-- PC 버전 테이블 -->
    <div v-if="value.length > 0" class="hidden xl:block">
      <vs-row class="grid-title-11">
        <vs-col class="grid-title head">단위작업명</vs-col>
        <vs-col class="head">해당여부</vs-col>
      </vs-row>
      <vs-row v-for="(data, index) in value" :key="index" class="grid-title-11">
        <vs-col class="grid-title">
          <span v-if="isPrint" class="print-input">{{data[0]}}</span>
          <ml-input v-else class="w-full" v-model="data[0]"/>
        </vs-col>
        <vs-col class="grid-11">
          <div class="item">
            <div class="flex" style="align-items: center;">
              ①
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[1]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[1]"/>
            </div>
          </div>
          <div class="item">
            <div class="flex" style="align-items: center;">
              ②
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[2]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[2]"/>
            </div>
          </div>
          <div class="item">
            <div class="flex" style="align-items: center;">
              ③
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[3]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[3]"/>
            </div>
          </div>
          <div class="item">
            <div class="flex" style="align-items: center;">
              ④
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[4]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[4]"/>
            </div>
          </div>
          <div class="item">
            <div class="flex" style="align-items: center;">
              ⑤
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[5]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[5]"/>
            </div>
          </div>
          <div class="item">
            <div class="flex" style="align-items: center;">
              ⑥
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[6]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[6]"/>
            </div>
          </div>
          <div class="item">
            <div class="flex" style="align-items: center;">
              ⑦
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[7]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[7]"/>
            </div>
          </div>
          <div class="item">
            <div class="flex" style="align-items: center;">
              ⑧
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[8]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[8]"/>
            </div>
          </div>
          <div class="item">
            <div class="flex" style="align-items: center;">
              ⑨
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[9]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[9]"/>
            </div>
          </div>
          <div class="item">
            <div class="flex" style="align-items: center;">
              ⑩
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[10]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[10]"/>
            </div>
          </div>
          <div class="item">
            <div class="flex" style="align-items: center;">
              ⑪
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[11]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[11]"/>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </div>

    <!-- 모바일 버전 테이블 -->
    <div v-if="value.length > 0" class="block xl:hidden mt-6">
      <h6 class="mb-4 font-semibold">단위작업명 및 해당여부</h6>
      <div v-for="(data, index) in value" :key="index" class="mobile-task-item">
        <div class="mobile-task-header">
          <span v-if="isPrint" class="mobile-task-title print-input">{{data[0]}}</span>
          <ml-input v-else class="w-full" v-model="data[0]" placeholder="단위작업명"/>
          <span v-if="!isPrint" class="mobile-task-delete-btn" @click="removeSpecificItem(index)">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.3335 10.0013C3.3335 9.54106 3.70659 9.16797 4.16683 9.16797H15.8335C16.2937 9.16797 16.6668 9.54106 16.6668 10.0013C16.6668 10.4615 16.2937 10.8346 15.8335 10.8346H4.16683C3.70659 10.8346 3.3335 10.4615 3.3335 10.0013Z" fill="#FF5252"/>
            </svg>
          </span>
        </div>
        <div class="mobile-task-body">
          <div class="mobile-checkbox-row">
            <div class="mobile-checkbox-item">
              <span>① 호</span>
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[1]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[1]"/>
            </div>
            <div class="mobile-checkbox-item">
              <span>② 호</span>
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[2]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[2]"/>
            </div>
            <div class="mobile-checkbox-item">
              <span>③ 호</span>
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[3]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[3]"/>
            </div>
          </div>
          <div class="mobile-checkbox-row">
            <div class="mobile-checkbox-item">
              <span>④ 호</span>
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[4]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[4]"/>
            </div>
            <div class="mobile-checkbox-item">
              <span>⑤ 호</span>
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[5]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[5]"/>
            </div>
            <div class="mobile-checkbox-item">
              <span>⑥ 호</span>
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[6]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[6]"/>
            </div>
          </div>
          <div class="mobile-checkbox-row">
            <div class="mobile-checkbox-item">
              <span>⑦ 호</span>
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[7]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[7]"/>
            </div>
            <div class="mobile-checkbox-item">
              <span>⑧ 호</span>
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[8]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[8]"/>
            </div>
            <div class="mobile-checkbox-item">
              <span>⑨ 호</span>
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[9]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[9]"/>
            </div>
          </div>
          <div class="mobile-checkbox-row">
            <div class="mobile-checkbox-item">
              <span>⑩ 호</span>
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[10]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[10]"/>
            </div>
            <div class="mobile-checkbox-item">
              <span>⑪ 호</span>
              <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="data[11]" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
              <vs-checkbox v-else v-model="data[11]"/>
            </div>
            <div class="mobile-checkbox-item"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 모바일 항목추가 버튼 -->
    <div class="block xl:hidden mt-4">
      <button class="mobile-add-btn" @click="addItem">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8335 4.16536C10.8335 3.70513 10.4604 3.33203 10.0002 3.33203C9.53993 3.33203 9.16683 3.70513 9.16683 4.16536V9.16537H4.16683C3.70659 9.16537 3.3335 9.53846 3.3335 9.9987C3.3335 10.4589 3.70659 10.832 4.16683 10.832H9.16683V15.832C9.16683 16.2923 9.53993 16.6654 10.0002 16.6654C10.4604 16.6654 10.8335 16.2923 10.8335 15.832V10.832H15.8335C16.2937 10.832 16.6668 10.4589 16.6668 9.9987C16.6668 9.53846 16.2937 9.16537 15.8335 9.16537H10.8335V4.16536Z" fill="#FFFFFF"/>
        </svg>
        항목추가
      </button>
    </div>
  </div>

  <popup-alert v-model="alert.show"
               :title="alert.title"
               :html="alert.html"
               :buttons="alert.buttons"
  ></popup-alert>
</div>
</template>

<script>
import PopupAlert from '@/popup/PopupAlert'
export default {
  name: 'MusculoskeletalTensionExercisesTable',
  components: {PopupAlert},
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    isPrint: Boolean,
    readonly: Boolean,
  },
  data () {
    return {
      alert: {
        show: false,
        title: '통증 기준표',
        html:
          '<div style="width: 540px; padding: 24px;">' +
          '<p style="font-size: 16px;"><b>약한 통증 : </b>약간 불편한 정도이나 작업에 열중할 때는 못 느낀다</p>' +
          '<p style="font-size: 16px;"><b>중간 통증 : </b>작업 중 통증이 있으나 귀가 후 휴식을 취하면 괜찮다</p>' +
          '<p style="font-size: 16px;"><b>심한 통증 : </b>작업 중 통증이 비교적 심하고 귀가 후에도 통증이 계속된다</p>' +
          '<p style="font-size: 16px;"><b>매우 심한 통증 : </b>통증 때문에 작업은 물론 일상생활을 하기가 어렵다</p>' +
          '</div>',
        buttons: []
      },
      table: this.value,
    }
  },
  methods: {
    addItem () {
      this.table.push(['', false, false, false, false, false, false, false, false, false, false, false])
    },
    removeItem () {
      this.table.pop()
    },
    removeSpecificItem (index) {
      this.table.splice(index, 1)
    },
    showPopup (num) {
      let html = ''
      if (num === 1) {
        html = '하루에 4시간 이상 집중적으로 자료입력 등을 위해 키보드 또는 마우스를 조작하는 작업<br>' +
          '◈ "하루"란 잔업근무시간을 포함한 1일 총 근무시간을 의미함<br>' +
          '◈ "4시간" 이상은 근골격계부담작업에 실제 노출된 전체 누적시간을 의미<br>' +
          '◈ 집중적 자료입력이란 키보드 또는 마우스로 하는 동작이 지속적으로 이루어지는 것을 의미함<br>' +
          '※ 다만,컴퓨터를 통한 검색이나 해독 작업에서 일어나는 간헐적 입력작업, 쌍방향 통신, 정보 취득작업 등은 포함되지 않음<br>' +
          '※ 근로자가 임의로 자료입력 시간을 조절할 수 있는 경우에는 집중적으로 수행되는 작업으로 보지 아니함'
      } else if (num === 2) {
        html = '하루에 총 2시간 이상 목,어깨,팔꿈치, 손목 또는 손을 사용하여 같은 동작을 반복하는 작업<br>' +
          '◈ "총 2시간 이상"은 근골격계부담작업에 실제 노출된 전체 누적시간을 의미 함<br>' +
          '◈ "같은 동작"은 동작이 동일할 필요는 없으나,해당 동작들이 같은 근육군을 사용하여 이루어지는 것을 의미함<br>' +
          '※반복횟수(참고) 어깨(4회/분),팔꿈치(10회/분),손목(20회/분),손(200회/분)'
      } else if (num === 3) {
        html = '하루에 총 2시간 이상 머리 위에 손이 있거나, 팔꿈치가 어깨 위에 있거나, 팔꿈치를 몸통으로부터 들거나,팔꿈치를 몸통뒤쪽에 위치하도록 하는 상태에서 이루어지는 작업<br>' +
          '◈ 이 기준에서 "팔꿈치를 몸통으로부터 드는 경우"란 "수직상태를 기준으로 위 팔(어깨-팔꿈치)이 중력에 반하여 몸통으로부터 전방 내지 측방으로 45도이상 벌어져 있는 상태"를 말함<br>' +
          '◈ 동 기준에 의한 부담작업의 누적시간은 각 신체부위별 부담작업 시간을 각각합산한 총 누적시간으로 평가하되,한 작업자세에서 여러 신체부위가 동시에 부담작업에 해당되는 경우에는 그 중 하나의 신체부위 작업시간만을 총 누적시간에 반영<br>' +
          '※[예시]하루 작업시간중 머리 위에 손이 위치하는 작업 및 팔꿈치가 어깨 위에 있는 상태에서의 작업이 각각 1시간씩인 경우에는 동 기준에 의한 부담작업은 총 2시간(손+팔꿈치)이됨'
      } else if (num === 4) {
        html = '지지되지 않은 상태이거나 임의로 자세를 바꿀 수 없는 조건에서, 하루에 총 2시간이상 목이나 허리를 구부리거나 트는 상태에서 이루어지는 작업<br>' +
          '◈ 이 기준에서 "지지되지 않은 상태"란 "목이나 허리를 구부리거나 비튼 상태에서 발생하는 신체부담을 해소시켜 줄 수 있는 부담 신체부위에 대한 지지대가 없는경우"를 의미함<br>' +
          '◈ "임의로 자세를 바꿀 수 없는 조건"이란 "근로자 본인이 목이나 허리를 구부리거나 트는 상태를 취하고 싶지 않아도 작업을 하기 위해서는 모든 근로자가 어쩔 수 없이 그러한 자세를 취할 수밖에 없는 경우"를 말함<br>' +
          '◈ "목이나 허리의 굽힘"은 "특별한 사정이 없는 한 수직상태를 기준으로 목이나 허리를 전방으로 20도 이상 구부리거나 허리를 후방으로 20도 이상 제치는 경우"를 의미하며, 무릎을 바닥에<br>' +
          '앞으로 누워있는 경우는 허리의 굽힘으로 보지 않음<br>' +
          '◈ "목이나 허리를 튼 상태"는 "특별한 사정이 없는 한 목은 어깨를 고정한 상태에서 5도 이상,허리는 다리를 고정한 상태에서 20도 이상 좌우로 비튼 상태"를 말함'
      } else if (num === 5) {
        html = '하루에 총 2시간 이상 쪼그리고 앉거나 무릎을 굽힌 자세에서 이루어지는 작업<br>' +
          '◈ 이 기준에서 "쪼그리고 앉는 것"은 "수직상태를 기준으로 무릎이 발끝 보다 앞으로 나오는 자세 이상으로 무릎을 구부린 상태에서 발이 체중의 대부분을 지탱하고 있는 상태"를 말함<br>' +
          '◈ "무릎을 굽힌 자세"는 "바닥 면에 한쪽 또는 양쪽 무릎을 댄 상태에서 해당무릎이 체중의 대부분을 지탱하고 있는 자세"를 의미함'
      } else if (num === 6) {
        html = '하루에 총 2시간 이상 지지되지 않은 상태에서 1kg이상의 물건을 한손의 손가락으로 집어 옮기거나,2kg이상에 상응하는 힘을 가하여 한손의 손가락으로 물건을 쥐는 작업<br>' +
          '◈ 이 기준에서 "지지되지 않는 상태"란 "순전히 혼자만의 힘으로 손가락으로 집어 옮기거나 한 손의 손가락으로 물건을 쥐는 것"을 말함<br>' +
          '◈ "1kg(2kg)에 상응하는 힘"이란 "A4용지 약 125매(250매)를 손가락으로 집어 올리거나(한 손의 손가락으로 쥐는데)사용하는 정도의 힘"을 의미하며 이를 평가할 때는 물체의 부피나 무게와 관계없이 손가락으로 집어 올리는 것 (한 손의 손가락으로 쥐는 것)을 여러 번 반복한 다음 A4용지 약 125매(250매) 를 손가락으로 집어 올리는 것과 비교<br>' +
          '※물건의 무게와 무관하게 어느 정도의 쥐는 힘이 사용되는지는 비교평가방법을 사용함(근로자에게 해당 작업을 여러번 반복하게 한 다음 A4용지 약 250매 정도를 다루는 힘과 비교하게 함)'
      } else if (num === 7) {
        html = '하루에 총 2시간 이상 지지되지 않은 상태에서 4.5kg이상의 물건을 한 손으로 들거나 동일한 힘으로 쥐는 작업<br>' +
          '◈ 이 기준에서 "지지되지 않은 상태"란 "순전히 혼자만의 힘으로 물건을 한 손으로 들거나 쥐는 상태"를 말함<br>' +
          '◈ "4.5kg의 물체를 한 손으로 드는 것과 동일한 힘"이란 "소형 자동차용 점프선의 집게를 한 손으로 쥐어서 여는 정도의 힘"에 해당되며,이를 평가할 때는 물체의 부피나 무게와 관계없이 한 손으로 물건을 들거나 쥐게 하는 것을 여러 번 반복한 다음 소형 자동차용 점프선의 집게를 한 손으로 쥐어서 여는 것과 비교'
      } else if (num === 8) {
        html = '하루에 10회 이상 25kg이상의 물체를 드는 작업<br>' +
          '◈ 대상물을 들어올리거나 내리거나 쌓는 작업만 해당됨, 25kg이상이기는 하나 10회가 안되고, 24kg이나 10회가 넘는 경우에는 해당되지 않음, 다만, 제9호, 10호에 해당되는지 여부 판단(이 기준은 중량물을 중력에 반하여 드는 경우에만 적용,중량물을 밀거나 당기는 작업은 해당되지 않음)<br>' +
          '◈ 근로자 2인 이상이 작업을 하는 경우 특별한 사유가 없는 한 작업자수로 나눈 물체의 무게로 계산함<br>' +
          '◈ 다만,2인 이상이 실시하는 중량물 취급작업의 경우 개인의 무게부하에 대하여 노사간 이견이 있는 경우에는 실제 부하를 평가하여 근골격계부담작업 여부결정'
      } else if (num === 9) {
        html = '하루에 25회 이상 10kg이상의 물체를 무릎 아래에서 들거나,어깨 위에서 들거나,팔을 뻗은 상태에서 드는 작업<br>' +
          '◈ "무릎 아래에서 들거나 어깨 위에서 들거나"는 물체가 무릎 아래 혹은 어깨 위에 있는 것이 아니라,물체를 들고 있는 손의 위치가 무릎 아래 혹은 어깨 위에 있는 상태를 의미함<br>' +
          '◈"팔을 뻗은 상태"라 함은 중력에 반하여 팔을 들어 팔꿈치를 편 상태를 의미하며 중력의 방향으로 늘어뜨린 경우(중립자세)는 제외함'
      } else if (num === 10) {
        html = '하루에 총 2시간 이상,분당 2회 이상 4.5kg 이상의 물체를 드는 작업<br>' +
          '◈ 분당 2회 이상 4.5kg이상의 물체를 드는 경우 노출시간은 1분으로 계산'
      } else if (num === 11) {
        html = '하루에 총 2시간 이상 시간당 10회 이상 손 또는 무릎을 사용하여 반복적으로 충격을 가하는 작업<br>' +
          '◈ 근로자가 강하고 빠른 충격을 전달하기 위하여 손 또는 무릎을 망치처럼 사용하는 작업을 말함 ※예시)단단하게 끼워지는 부품 조립,카펫 까는 작업'
      }
      this.alert.title = `근골격계부담작업 제${num}호`
      this.alert.html = `<div style="width: 100%; max-width: 800px;">${html}</div>`
      this.alert.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-title-11 {
  display: grid !important;
  grid-template-columns: 160px 1fr;

  .head {
    text-align: center;
    background-color: #F9F9F9;
    padding: 7px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
  }
  .grid-title {
    padding: 7px;
  }

  & >.grid-11 {
    display: grid;
    grid-template-columns: repeat(11, minmax(115px, 1fr));

    & > .item {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 7px;
      border-right: 1px solid #cdcdcd;
      border-bottom: 1px solid #cdcdcd;
      text-align: center;

      &:last-child {
        border-right: none;
      }
    }

  }
}
.print-radio,
.print-checkbox {
  display: flex;
  align-items: center;
  margin-right: 1rem;

  & > i { width:20px; height: 20px; border:2px solid #cdcdcd; position: relative; margin-right: 6px; }
  & .feather-icon { transform: translateY(-4px); }
}
.print-radio {
  & > i { border-radius: 20px; }
}

// 모바일 카드 스타일
.mobile-cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.mobile-card {
  border: 1px solid #cdcdcd;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.mobile-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #F9F9F9;
  padding: 12px 16px;
  border-bottom: 1px solid #cdcdcd;
  cursor: pointer;
}

.mobile-card-title {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mobile-card-number {
  font-weight: 700;
  font-size: 16px;
  color: #200c63;
}

.mobile-card-img {
  width: 45px;
  height: 45px;
  object-fit: contain;
}

.mobile-card-body {
  padding: 16px;
}

.mobile-card-item {
  display: flex;
  margin-bottom: 12px;
  gap: 12px;
}

.mobile-card-item:last-child {
  margin-bottom: 0;
}

.mobile-card-label {
  font-weight: 600;
  font-size: 14px;
  color: #200c63;
  min-width: 100px;
}

// 모바일 테이블 스타일
.mobile-task-item {
  margin-bottom: 20px;
  border: 1px solid #cdcdcd;
  border-radius: 8px;
  overflow: hidden;
}

.mobile-task-header {
  background-color: #F9F9F9;
  padding: 12px;
  border-bottom: 1px solid #cdcdcd;
  display: flex;
  align-items: center;
}

.mobile-task-title {
  font-weight: 600;
}

.mobile-task-body {
  padding: 12px;
}

.mobile-checkbox-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.mobile-checkbox-row:last-child {
  margin-bottom: 0;
}

.mobile-checkbox-item {
  display: flex;
  align-items: center;
  flex: 1 0 30%;
  min-width: 100px;
  margin-bottom: 8px;
  gap: 8px;
}

.mobile-task-delete-btn {
  cursor: pointer;
  color: #FF5252;
  margin-left: 10px;
  display: flex;
  align-items: center;
}

.mobile-add-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #7E72F2;
  color: #fff;
  padding: 10px 16px;
  border-radius: 6px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  width: 100%;
  justify-content: center;
}

.mobile-add-btn:hover {
  background-color: #6A5FE0;
}
</style>
